import { ListAgenticLogicPlacementsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const listAgenticLogicPlacements = async () => {
  const resp = await api.get<ListAgenticLogicPlacementsResponseBodyType>(
    `/v2/agentic-logic/placements`
  );
  return resp.data;
};

export const useAgenticLogicPlacements = () => {
  return useQuery<ListAgenticLogicPlacementsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.placements(),
    queryFn: async () => listAgenticLogicPlacements(),
  });
};
